<script setup lang="ts">
import type {currenciesCommon, languagesCommon} from "~~/schemas/main.schema.dto";
import {useHttpStore} from "~/composables/stores/http.store";
import {useDataStore} from "~/composables/stores/data.store";

let http = useHttpStore()
let data = useDataStore()
let router = useRouter()
const {locale, t} = useI18n()
let localePath = useLocalePath()
let toast = useToast()

watch(() => locale.value, () => {
  let currency: currenciesCommon = 'huf'
  if (locale.value === 'en') {
    currency = 'euro'
  }
  data.$patch({
    lang: locale.value as languagesCommon,
    currency: currency
  })
}, {immediate: true})

http.$subscribe((mutation, state) => {
  if (state.pendingLogout) {
    router.push(localePath('/'))
    state.pendingLogout = false
  }
})


</script>


<template>
  <Head>
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="true">
    <link href="https://fonts.googleapis.com/css2?family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap"
          rel="stylesheet">
    <link
        href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap"
        rel="stylesheet">
  </Head>
  <Html>
  <Body class="">
  </Body>
  </Html>
  <NuxtRouteAnnouncer/>
  <NuxtLoadingIndicator :height="6" color="repeating-linear-gradient(to right, #f271b5 0%, #ff0088 50%, #f271b5 100%)"/>
  <UApp>
    <NuxtLayout>
      <NuxtPage/>
    </NuxtLayout>
  </UApp>

</template>


<style>
.blurFade-enter-active,
.blurFade-leave-active {
  transition: all 0.1s;
}

.blurFade-enter-from,
.blurFade-leave-to {
  opacity: 10%;
  filter: blur(1rem);
}

.leftToRight-enter-active {
  transition: all 0.9s;
}

.leftToRight-leave-active {
  transition: all 0.3s;
}

.leftToRight-enter-from {
  transform: translateX(-100%);
}

.leftToRight-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

@media (min-width: 640px) {
}

@media (min-width: 768px) {
}

@media (min-width: 1024px) {
}

@media (min-width: 1280px) {
}

@media (min-width: 1536px) {
}
</style>
